<div>
    <div class="file-uploader">
        <div class="form-group">
            <div class="row">
                <div class="col-xs-6">
                    <h5 class="col-sm-12 mt-2">{{title}} <span>{{'FORM.PHOTO.NOT_REQUIRED' | translate}}</span></h5>
                </div>
                <div class="col-xs-6 text-right" *ngIf="file || file.photo">
                    <button type="button" class="btn btn-link btn-delete" (click)="deleteFile(file)">{{'FORM.PHOTO.DELETE' | translate}} <i class="fa fa-times-circle"></i></button>
                </div>
            </div>
            <div ng2FileDrop [ngClass]="{'card--error': isTooBig || isNotImage || isServerError}" class="card text-center" (ng2FileDropFileAccepted)="dragFileAccepted($event)" *ngIf="!file || !file.photo">
                <div class="hidden-xs file-uploader-icon">
                    <p class="file-uploader-icon__text">{{'FORM.PHOTO.DRAGDROP' | translate}}</p>
                </div>
                <div class="file-uploader-button">
                    <label class="btn btn-default btn-select-photo" [for]="mediaId">{{btn}}</label>
                    <input type="file" [id]="mediaId" class="sr-only" accept="image/*" (change)="uploadFiles()" lang="EN">
                </div>
            </div>
            <img class="file-uploader-preview" [src]="file.photo4SafePreview" *ngIf="file && file.photo4SafePreview" (click)="showFullScreen = true" />
        </div>
        <div class="text-danger " *ngIf="isTooBig || isNotImage || isServerError ">
            <span *ngIf="isTooBig ">{{ 'ERRORS.fileTooBig' | translate}}</span>
            <span *ngIf="isNotImage ">{{ 'ERRORS.notAnImage' | translate}}</span>
            <span *ngIf="isServerError ">{{ 'ERRORS.refusedByCloudinary' | translate}}</span>
        </div>
    </div>
</div>